import { memo } from "react"
import { useTranslation } from "react-i18next"

export const RowHead = memo(() => {
  const {t} = useTranslation()
  return (
    <tr>
      <th>{t('kontrak-soNomor')}</th>
      <th>{t('Order Number')}</th>
      <th>{t('TableBank.status')}</th>
      <th>{t('Sector')}</th>
      <th>{t('Customer Name')}</th>
      <th>{t('kontrak-produsen')}</th>
      <th>{t('Total Kuantum')}</th>
    </tr>
  )
})
